import React from "react"
import IngSlider from "./slider"

const Carousel = ({ images, title, isDesign=false }) => {

    return (
        <IngSlider images={images} title={title} isDesign={isDesign} />
    )
}

export default Carousel

